import { FC } from 'react'
import { SocialMediaProps } from './interfaces'

const Tiktok: FC<SocialMediaProps> = ({
  width = 20,
  height = 20,
  color = 'white',
}) => {
  const fillColor = {
    white: '#FFFFFF',
    'grey-500': '#75787B',
    black: '#212721',
  }
  const DEFAULT_COLOR = fillColor.white

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.957031 13.0655C0.962872 12.9889 0.968712 12.9137 0.974553 12.837C1.02566 12.0985 1.21839 11.3963 1.55422 10.7303C1.97328 9.90122 2.56755 9.20454 3.33265 8.64301C4.11236 8.07313 4.98697 7.70528 5.95358 7.54086C6.39453 7.46562 6.83841 7.43358 7.28667 7.46423C7.31879 7.46702 7.35092 7.4698 7.3845 7.47398V10.3137C7.31003 10.3053 7.23849 10.2969 7.1684 10.2914C6.85593 10.2635 6.54931 10.2983 6.24706 10.3722C5.81341 10.4781 5.41917 10.662 5.07312 10.9337C4.44381 11.4283 4.04665 12.0581 3.95321 12.8342C3.81741 13.9615 4.22625 14.8867 5.16365 15.5875C5.5681 15.8899 6.03534 16.0752 6.54493 16.1393C7.55095 16.2675 8.44017 16.0055 9.20235 15.3715C9.71048 14.9494 10.0361 14.4185 10.1704 13.7859C10.2098 13.5992 10.2244 13.4111 10.2244 13.2202C10.2332 9.44419 10.2405 5.66819 10.2493 1.89218C10.2493 1.2805 10.2522 0.670206 10.2536 0.0585211C10.2536 0.0404074 10.2536 0.0209004 10.2536 0H13.1023C13.1184 0.100322 13.1315 0.199251 13.1491 0.298179C13.26 0.948878 13.4937 1.55638 13.8587 2.11512C14.599 3.24653 15.643 3.99616 16.9892 4.35843C17.3046 4.44343 17.6258 4.49498 17.9514 4.51867C17.9996 4.52285 18.0011 4.54375 18.0011 4.57858C18.0011 5.36026 18.0011 6.14193 18.0011 6.92361C18.0011 7.16605 18.0011 7.40989 18.0011 7.65233C18.0011 7.66209 17.9996 7.67045 17.9981 7.68577C17.0213 7.76938 16.0898 7.61332 15.2064 7.20785C14.3245 6.80238 13.6149 6.20742 13.0629 5.43132V5.48984C13.0629 8.0578 13.0629 10.6258 13.0629 13.1937C13.0629 14.0743 12.8716 14.9145 12.473 15.7101C12.0978 16.4584 11.578 17.0993 10.9136 17.6358C10.2142 18.1987 9.42137 18.5916 8.53654 18.8131C7.88824 18.9748 7.22973 19.0319 6.56099 18.9831C5.60753 18.9149 4.71977 18.6473 3.89918 18.1778C3.29323 17.8308 2.76467 17.3947 2.31933 16.8694C1.66373 16.0975 1.24322 15.2225 1.05778 14.2443C0.996455 13.9211 0.965792 13.5964 0.965792 13.2676C0.965792 13.2104 0.959951 13.1519 0.957031 13.0948V13.0669L0.957031 13.0655Z"
        fill={fillColor[color] || DEFAULT_COLOR}
      />
    </svg>
  )
}

export default Tiktok
